import { Profile } from '@app/core/models/profile';
import { Coverage } from '@app/core/models/coverage';
import { Needs } from '@app/core/models/needs';
import { AgentInfo } from '@app/core/models/agent';
import { Save } from './save';

export class Kyc {
  agentInfo: AgentInfo;
  profile: Profile;
  coverage: Coverage;
  needs: Needs;
  save: Save;

  constructor() {
    this.coverage = new Coverage();
    this.profile = new Profile();
    this.needs = new Needs();
    this.save = new Save();
  }

  complete() {
    this.profile.completed = true;
    this.coverage.completed = true;
    this.needs.completed = true;
    this.save.completed = true;
  }
}



// WEBPACK FOOTER //
// ./src/app/core/models/kyc.ts